import { AdvancedFilterDataSchema } from "@redotech/redo-model/views/views";
import * as z from "zod/v4";

const inventoryMerchantSchema_ = z.object({ id: z.string(), name: z.string() });

export const InventoryMerchantSchema: z.ZodType<InventoryMerchant> =
  inventoryMerchantSchema_;
export interface InventoryMerchant
  extends z.infer<typeof inventoryMerchantSchema_> {}

export const getInventoryMerchants = {
  name: "getInventoryMerchants" as const,
  input: z.object({
    search: z.string().optional(),
    advancedFiltersData: z.array(AdvancedFilterDataSchema).optional(),
  }),
  output: z.object({ merchants: z.array(InventoryMerchantSchema) }),
};
